import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectSetting } from '../../../../util/store/selectors';
import { ISite } from '../../../../util/varibles/interface';
import { PlanSetting } from '../../../../util/varibles/userSetting';
import { updateUserSetting } from "../../../LoginPage/reducer";
import ProdAreaFilter from '../_components/ProdAreaFilter';

const Filter: React.FC<{ sites: ISite[], siteFilter: number }> = (props) => {
    const { [PlanSetting.LOCATION_PROD_AREA]: prodAreaFilter } = useSelector(selectSetting([PlanSetting.LOCATION_PROD_AREA]))

    const dispatch = useDispatch();
    const updateSetting = ({ prodAreaFilter }: { prodAreaFilter: string[] }) => {
        dispatch(updateUserSetting([{ [PlanSetting.LOCATION_PROD_AREA]: prodAreaFilter }]))
    }

    return <ProdAreaFilter
        {...props}
        prodAreaFilter={prodAreaFilter || []}
        updateSetting={updateSetting}
    />
};

export default Filter
